export const BAY_CAPACITY_COLOR_CODES = {
  low: '#d6654a',
  medium: '#ecca19',
  high: '#90cc11',
};

export const BAY_INSPECTION_STATUS_COLOR_CODES = {
  incomplete: '#d6654a',
  complete: '#90cc11',
  excluded: '#838383',
};

export const UPRIGHT_INSPECTION_STATUS_COLOR_CODES = {
  incomplete: '#ff9016',
  complete: '#62a535',
  excluded: '#f0f0f0',
};

export const SELECTED_ISSUE_SCALE = 2;
export const BAY_STROKE_WIDTH = 15;

export const DEFAULT_CANTILEVER_BAY_CFG = {
  strokeWidth: 3,
};

export const DEFAULT_BAY_CFG = {
  fill: '#f0f0f0',
  stroke: '#838383',
  strokeWidth: 2,
};

export const DEFAULT_BAY_STROKE_CFG = {
  fill: '#00000080',
};

export const DEFAULT_BAY_TEXT_CFG = {
  fill: '#000',
  fontSize: 24,
  fontFamily: 'Open Sans',
  fontWeight: 'normal',
};

export const DEFAULT_BAY_ICON_CFG = {
  fill: '#000',
  fontSize: 36,
  fontFamily: 'Material Icons',
};

export const NOTE_BAY_ICON_CFG = {
  fill: 'rgba(0, 0, 0, 0.25)',
  fontSize: 24,
  fontFamily: 'Material Icons',
};

export const DEFAULT_CAPACITY_TEXT_CFG = {
  ...DEFAULT_BAY_TEXT_CFG,
  fontWeight: 'normal',
  fontSize: 16,
};

export const DEFAULT_ISSUE_CFG = {
  radius: 20,
};

export const DEFAULT_REPAIR_CFG = {
  size: 40,
  fill: '#79c447',
};

export const DEFAULT_OUTLINE_CFG = {
  stroke: '#565656',
  strokeWidth: 2,
};
